import { createDraftJobPost } from './CreateDraftJobPost';
import { createOnsiteInterviews } from './CreateOnsiteInterview';
import { createShortlistCandidate } from './CreateShortlistCandidate';
import { deleteDraftJob } from './DeleteDraftJob';
import { deleteShortlistCandidate } from './DeleteShortlistCandidate';
import { getCandidateList } from './GetCandidateList';
import { getCandidateProfessional } from './GetCandidateProfessional';
import { getCandidateResume } from './GetCandidateResume';
import { getJobPostDetail } from './GetJobPostDetail';
import { getJobPostings } from './GetJobPostings';
import { getOfficePlanDetail } from './GetOfficePlanDetail';
import { getOnsiteInterviewList } from './GetOnsiteInterviewList';
import { getOnsiteInterviewStatusCount } from './GetOnsiteInterviewStatusCount';
import { getPostingPlans } from './GetPostingPlans';
import { publishDraftJobPost } from './PublishDraftJobPost';
import { retryBilling } from './RetryBilling';
import { saveJobPostDetail } from './SaveJobPostDetail';
import { updateCandidateStatus } from './UpdateCandidateStatus';

export const PermanentJobsApi = {
  createDraftJobPost,
  createOnsiteInterviews,
  createShortlistCandidate,
  deleteDraftJob,
  deleteShortlistCandidate,
  getCandidateList,
  getCandidateProfessional,
  getCandidateResume,
  getJobPostDetail,
  getJobPostings,
  getOfficePlanDetail,
  getOnsiteInterviewList,
  getOnsiteInterviewStatusCount,
  getPostingPlans,
  publishDraftJobPost,
  retryBilling,
  saveJobPostDetail,
  updateCandidateStatus,
};
